"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const slice_2 = require("../../../app-reduxs/articleCreating/slice");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const components_1 = require("../../../components");
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const ModalConfirmDeleteArticle_1 = __importDefault(require("../../../components/modal/ModalConfirmDeleteArticle"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const Article_1 = __importDefault(require("../../../networking/apis/Article"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const CreateArticleConfirm = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigation = (0, native_1.useNavigation)();
    const articleCreating = (0, react_redux_1.useSelector)((state) => state.articleCreatingReducer);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [visible, setVisible] = (0, react_1.useState)(false);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const isArticle = articleCreating.content_type == 1;
    (0, react_1.useEffect)(() => {
        if (!articleCreating.content_type) {
            navigation.reset({ index: 0, routes: [{ name: Routes_1.default.MAINTABBAR }] });
        }
    }, [articleCreating]);
    (0, react_1.useEffect)(() => {
        const handleBeforeUnload = (event) => {
            const message = 'Are you sure you want to leave?';
            event.returnValue = message;
            return message;
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
    const handlePostArticle = async (status) => {
        const form = new FormData();
        if (!!articleCreating.inherited_from_article_id) {
            form.append('inherited_from_article_id', `${articleCreating.inherited_from_article_id}`);
        }
        if (!!articleCreating.inherited_from_user_id) {
            form.append('inherited_from_user_id', `${articleCreating.inherited_from_user_id}`);
        }
        form.append('title', articleCreating.title);
        form.append('content_type', `${articleCreating.content_type}`);
        if (!!articleCreating.thumbnail_image) {
            const file = await (0, helpler_1.convertImageUrlToFile)(articleCreating.thumbnail_image);
            if (file) {
                form.append('thumbnail_image', file);
            }
        }
        form.append('price_type', '1');
        const contentResizeImage = (0, helpler_1.changeWidthHeightToPercentage)(articleCreating.full_text);
        form.append('full_text', contentResizeImage);
        // form.append('full_text', articleCreating.full_text)
        form.append('posting_datetime', (0, moment_1.default)().format('YYYY-MM-DD HH:mm:ss'));
        form.append('status', `${status}`);
        articleCreating.hashtags.map((item, index) => {
            form.append(`hash_tag_name[${index}]`, item);
        });
        setLoading(true);
        Article_1.default.postArticle(form)
            .then((response) => {
            const message = status == 0 ?
                "下書きに保存しました"
                :
                    articleCreating.content_type == 1 ?
                        "記事を公開しました"
                        :
                            "自分史を公開しました";
            dispatch(slice_1.default.actions.showToast(message));
            (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                screen: Routes_1.default.DETAIL_STORY,
                params: {
                    id: response.data.article_id
                }
            });
            dispatch((0, slice_2.destroyArticleAction)());
        })
            .catch(error => {
            dispatch(slice_1.default.actions.setToastType(false));
            if (typeof error?.response?.data?.error?.message === 'string') {
                dispatch(slice_1.default.actions.showToast(error?.response?.data?.error?.message));
            }
            else {
                dispatch(slice_1.default.actions.showToast('予期せぬエラーが発生しました。'));
            }
        })
            .finally(() => {
            setLoading(false);
        });
    };
    const handleEditArticle = async (status) => {
        const form = new FormData();
        form.append('title', articleCreating.title);
        form.append('content_type', `${articleCreating.content_type}`);
        if (!!articleCreating.thumbnail_image) {
            const file = await (0, helpler_1.convertImageUrlToFile)(articleCreating.thumbnail_image);
            if (file) {
                form.append('thumbnail_image', file);
            }
        }
        if (!!articleCreating.inherited_from_user_id && articleCreating.inherited_from_user_id != articleCreating.inherited_from_user_id_root) {
            form.append('inherited_from_user_id', `${articleCreating.inherited_from_user_id}`);
        }
        form.append('price_type', '1');
        const contentResizeImage = (0, helpler_1.changeWidthHeightToPercentage)(articleCreating.full_text);
        form.append('full_text', contentResizeImage);
        // form.append('full_text', articleCreating.full_text)
        form.append('status', `${status}`);
        articleCreating.hashtags.map((item, index) => {
            form.append(`hash_tag_name[${index}]`, item);
        });
        setLoading(true);
        Article_1.default.editArticle(articleCreating.article_id, form)
            .then(() => {
            const message = status == 0 ?
                "編集しました"
                :
                    articleCreating.content_type == 1 ?
                        "記事を公開しました"
                        :
                            "自分史を公開しました";
            dispatch(slice_1.default.actions.showToast(message));
            navigation.dispatch(native_1.StackActions.popToTop());
            (0, rootNavigation_1.navigate)(Routes_1.default.DETAIL_STORY, { id: articleCreating.article_id });
            dispatch((0, slice_2.destroyArticleAction)());
        })
            .catch(error => {
            dispatch(slice_1.default.actions.setToastType(false));
            if (typeof error?.response?.data?.error?.message === 'string') {
                dispatch(slice_1.default.actions.showToast(error?.response?.data?.error?.message));
            }
            else {
                dispatch(slice_1.default.actions.showToast('予期せぬエラーが発生しました。'));
            }
        })
            .finally(() => {
            setLoading(false);
        });
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: articleCreating.content_type == 2 ? '自分史作成' : '記事作成', styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(CustomText_1.default, { style: styles_1.default.headerText }, "\u30AD\u30E3\u30F3\u30BB\u30EB"), onLeftPress: () => setVisible(true) }),
        react_1.default.createElement(react_native_1.ScrollView, { style: { flex: 1 }, contentContainerStyle: {
                paddingHorizontal: (0, scale_1.scale)(16),
                paddingVertical: (0, scale_1.scale)(24),
            }, showsVerticalScrollIndicator: false },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.row },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.decor }),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.title }, "\u767B\u9332\u78BA\u8A8D")),
            react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.descriptionBold }, "\u307E\u3060\u516C\u958B\u304C\u5B8C\u4E86\u3057\u3066\u3044\u307E\u305B\u3093"),
            react_1.default.createElement(CustomText_1.default, { style: styles_1.default.description },
                "\u5165\u529B\u3057\u305F",
                isArticle ? '記事' : '自分史',
                "\u306E\u5185\u5BB9\u3092\u78BA\u8A8D\u3057\u3066\u304B\u3089\u516C\u958B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.box },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.row, { justifyContent: 'space-between' }] },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.boxTitle },
                        isArticle ? '記事' : '自分史',
                        "\u60C5\u5831"),
                    react_1.default.createElement(CustomText_1.default, { onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.CREATE_ARTICLE), style: [styles_1.default.boxTitle, { color: '#007AFF' }] }, "\u7DE8\u96C6")),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.boxContent }, articleCreating.title),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.boxBtn, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.CREATE_ARTICLE_PREVIEW) }, "\u30D7\u30EC\u30D3\u30E5\u30FC\u753B\u9762\u3092\u898B\u308B")),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.box },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.row, { justifyContent: 'space-between' }] },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.boxTitle }, "\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0"),
                    react_1.default.createElement(CustomText_1.default, { style: [styles_1.default.boxTitle, { color: '#007AFF' }], onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.CREATE_ARTICLE_HASHTAG) }, "\u7DE8\u96C6")),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.boxContent }, articleCreating.hashtags.map((it) => `#${it}  `))),
            (!articleCreating.article_id || articleCreating.status == 0) && (react_1.default.createElement(components_1.BorderButton, { title: "\u4E0B\u66F8\u304D\u306B\u4FDD\u5B58", style: styles_1.default.addHashtagBtn, textStyle: styles_1.default.addHashtagLabel, onPress: () => {
                    articleCreating.article_id ?
                        handleEditArticle(0)
                        :
                            handlePostArticle(0);
                } })),
            react_1.default.createElement(components_1.LinearButton, { title: "\u516C\u958B", style: styles_1.default.nextBtn, containerStyle: { marginTop: (0, scale_1.scale)(12) }, textStyle: styles_1.default.nextBtnLabel, onPress: () => {
                    articleCreating.article_id ? handleEditArticle(1) : handlePostArticle(1);
                } })),
        react_1.default.createElement(ModalConfirmDeleteArticle_1.default, { visible: visible, onClose: () => setVisible(false), title: articleCreating.content_type == 2
                ? '自分史の作成を取り消しますか？'
                : '記事の作成を取り消しますか？', content: "\u5165\u529B\u3057\u305F\u5185\u5BB9\u306F\u4FDD\u5B58\u3055\u308C\u307E\u305B\u3093\u3002", confirmLabel: "\u4E0B\u66F8\u304D\u306B\u4FDD\u5B58\u3059\u308B", cancelLabel: "\u30AD\u30E3\u30F3\u30BB\u30EB", confirmLabel1: "\u7834\u68C4\u3059\u308B", onConfirm: () => { setVisible(false), articleCreating.article_id ? handleEditArticle(0) : handlePostArticle(0); }, onConfirm1: () => {
                setVisible(false);
                (0, rootNavigation_1.goBack)();
                (0, rootNavigation_1.goBack)();
                (0, rootNavigation_1.goBack)();
                dispatch((0, slice_2.destroyArticleAction)());
            } }),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = CreateArticleConfirm;
